const FACEBOOK = 'facebook';
const WHATSAPP = 'whatsapp';
const INSTAGRAM = 'instagram';
const TELEGRAM = 'telegram';
const MEET = 'meet';
const WEBINAIR = 'webinair';
const WEBINAIR_LABEL = 'webinar';
const ADO = 'ado';
const OTHER = 'other';
const PLATFORM = 'platform';


export const TeacherContactTypes = {
    FACEBOOK,
    WHATSAPP,
    INSTAGRAM,
    TELEGRAM,
    MEET,
    WEBINAIR,
    ADO,
    OTHER,
    PLATFORM,
    WEBINAIR_LABEL,
};
